import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { Customer, CustomerCreateDTO, CustomerPage } from '../interfaces/sales/customer.interface';

export const CustomerService = {
  listByInstitution: async (institutionId: string, page = 0, size = 10): Promise<CustomerPage> =>
    (await axios.get(`${ENDPOINTS.CUSTOMER.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`)).data,
  getById: async (id: string): Promise<Customer> =>
    (await axios.get(ENDPOINTS.CUSTOMER.GET_BY_ID(id))).data,
  create: async (dto: CustomerCreateDTO): Promise<Customer> =>
    (await axios.post(ENDPOINTS.CUSTOMER.CREATE, dto)).data,
  update: async (id: string, dto: CustomerCreateDTO): Promise<Customer> =>
    (await axios.put(ENDPOINTS.CUSTOMER.UPDATE(id), dto)).data,
  remove: async (id: string): Promise<void> =>
    (await axios.delete(ENDPOINTS.CUSTOMER.DELETE(id))).data,
};
